import type React from "react";
import { ReactComponent as Svg } from "./assets/appstore.svg";
import * as styles from "./Icon.module.scss";

type AppStoreProps = React.SVGProps<SVGSVGElement>;

export const AppStore = ({ className, ...props }: AppStoreProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
